module.exports = __webpack_public_path__ + "img/plage.63d7e637.png";